module.exports = __webpack_public_path__ + "static/media/pic2.b24ae6f7.jpg";